import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const MedalIcon = memo<ISvgProps>((props, { className }) => (
  <Svg className={className} width="28" height="28" viewBox="0 0 28 28" {...props}>
    <path
      id="Icon_awesome-medal"
      data-name="Icon awesome-medal"
      d="M12.236,7.15,8.456.85A1.75,1.75,0,0,0,6.955,0H.877A.875.875,0,0,0,.16,1.377L6.245,10.07A11.318,11.318,0,0,1,12.236,7.15ZM27.123,0H21.045a1.75,1.75,0,0,0-1.5.85l-3.781,6.3a11.321,11.321,0,0,1,5.992,2.919L27.84,1.377A.875.875,0,0,0,27.123,0ZM14,8.75a9.625,9.625,0,1,0,9.625,9.625A9.625,9.625,0,0,0,14,8.75Zm5.06,8.6-2.074,2.021.491,2.856a.628.628,0,0,1-.911.661L14,21.54l-2.565,1.348a.628.628,0,0,1-.911-.661l.491-2.856L8.941,17.35a.628.628,0,0,1,.347-1.071l2.867-.418,1.281-2.6a.629.629,0,0,1,1.127,0l1.281,2.6,2.867.418A.628.628,0,0,1,19.06,17.35Z"
      transform="translate(0)"
      fill="#3477eb"
    />
  </Svg>
));

MedalIcon.displayName = 'MedalIcon';

export default MedalIcon;
